module.exports = __webpack_public_path__ + "img/placeholder_mobile.b3552c2c.png";